import { updateListMethod } from '../../utils/list'
import {
  DR_UPDATE_LIST,
  DR_UPDATE_LIST_METHOD,
  DR_UPDATE_FORM,
  DR_UPDATE_FORM_ERROR,
  DR_UPDATE_FORM_FIELD,
  DR_UPDATE_PREVIEW,
  DR_UPDATE_DIALOG
} from '../actions/developmental-rubrics.actions'

const initialState = {
  list: [],
  totalList: 0,
  form: {},
  oldForm: {},
  formError: {},
  preview: null,
  dialog: null
}

const developmentalRubricsReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case DR_UPDATE_LIST:
      if (payload.curriculumId) {
        newState[payload.curriculumId] = { list: payload.data, totalList: payload.count, ids: payload.ids }
      } else {
        newState.list = payload.data
        newState.totalList = payload.count
        newState.ids = payload.ids
      }
      break
    case DR_UPDATE_LIST_METHOD:
      if (payload.curriculumId) {
        if (newState[payload.curriculumId]) {
          newState[payload.curriculumId].list = updateListMethod(
            payload.method,
            payload.data,
            newState[payload.curriculumId].list
          )
          if (payload.method === 'DELETE') {
            newState[payload.curriculumId].totalList--
          }
          if (payload.method === 'POST') {
            newState[payload.curriculumId].totalList++
          }
        } else {
          newState[payload.curriculumId] = {
            list: updateListMethod(payload.method, payload.data, []),
            totalList: 1
          }
        }
      } else {
        newState.list = updateListMethod(payload.method, payload.data, newState.list)
        if (payload.method === 'DELETE') {
          newState.totalList--
        }
        if (payload.method === 'POST') {
          newState.totalList++
        }
      }
      break
    case DR_UPDATE_FORM:
      newState.form = { ...payload }
      newState.oldForm = { ...payload }
      newState.formError = null
      break
    case DR_UPDATE_FORM_ERROR:
      newState.formError = payload
      break
    case DR_UPDATE_FORM_FIELD:
      if (payload.field === 'curriculumElements') {
        newState.form = { ...newState.form, [payload.field]: payload.value, lcs: [] }
        newState.formError = {
          ...newState.formError,
          [payload.field]: null,
          lcs: null,
          elementId: null,
          subElementId: null
        }
      } else {
        newState.form = { ...newState.form, [payload.field]: payload.value }
        newState.formError = { ...newState.formError, [payload.field]: null }
      }
      break
    case DR_UPDATE_PREVIEW:
      newState.preview = payload.preview
      newState.previewType = payload.type
      break
    case DR_UPDATE_DIALOG:
      if (payload.open === false) {
        newState.dialog = null
      }
      newState.dialog = {
        open: payload.open,
        type: payload.type,
        form: payload.form
      }
      break
    default:
      break
  }

  return newState
}

export default developmentalRubricsReducer
